import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterGroupAssignPipe'
})
export class FilterGroupAssignPipe implements PipeTransform {

    transform(list: any, arg: any): any {
        if (arg === '' || arg.length < 3) { return list; }
        const result = [];
        for (const value of list) {
            if (value.group.toLowerCase().indexOf(arg.toLowerCase()) > -1) {
                result.push(value);
            }
        }
        return result;
    }
}
